/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { CertRosetteIcon16Light } from './CertRosetteIcon16Light';
import { CertRosetteIcon16Regular } from './CertRosetteIcon16Regular';
import { CertRosetteIcon16Solid } from './CertRosetteIcon16Solid';
import { CertRosetteIcon20Light } from './CertRosetteIcon20Light';
import { CertRosetteIcon20Regular } from './CertRosetteIcon20Regular';
import { CertRosetteIcon20Solid } from './CertRosetteIcon20Solid';
import { CertRosetteIcon24Regular } from './CertRosetteIcon24Regular';
import { CertRosetteIcon24Solid } from './CertRosetteIcon24Solid';
import { CertRosetteIcon32Regular } from './CertRosetteIcon32Regular';
import { CertRosetteIcon64Regular } from './CertRosetteIcon64Regular';
var sizes = {
    16: {
        light: CertRosetteIcon16Light,
        regular: CertRosetteIcon16Regular,
        solid: CertRosetteIcon16Solid,
    },
    20: {
        light: CertRosetteIcon20Light,
        regular: CertRosetteIcon20Regular,
        solid: CertRosetteIcon20Solid,
    },
    24: {
        regular: CertRosetteIcon24Regular,
        solid: CertRosetteIcon24Solid,
    },
    32: {
        regular: CertRosetteIcon32Regular,
    },
    64: {
        regular: CertRosetteIcon64Regular,
    },
};
export var CertRosetteIcon = forwardRef('CertRosetteIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
